import React from "react";
import {useQuery} from "@apollo/client";
import {GET_BACKEND_CONFIG} from "../commonQueries/getBackendConfig";


const HealthCheckRoute = () => {
    const {data: backendConfig} = useQuery(GET_BACKEND_CONFIG, {
        fetchPolicy: 'cache-first',
    });

    if (backendConfig) {
        return <>OK</>;
    }

    return <>Error</>;
};

export default HealthCheckRoute;